import React from 'react';
import  './../style/style.css';
import ReconnectingWebSocket from 'reconnecting-websocket';
import {endCall, uploadImage, getImages, deleteImage, getRecordedVideos, deleteVideo} from './../service.js';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Config from './../config.js';
import { EventEmitter } from 'events';
import PeerConnection from './peerconnection';
import RecordingRTCPeerConnection from './recrtcpeerconnection';
import CaptureImages from './captureimages';
import Div100vh from 'react-div-100vh';
import RecordedVideos from './recordedvideos';

const PING_INTERVAL = 15000;

class Agent extends React.Component {
  constructor(props) {
    super(props);
    this.videoTag = null;
    this.canvasTag = null;
    this.id = "";
    this.photoTag = null;
    this.peerConnection = null;
    this.recordingToastID = null;
    this.iceQueue = [];
    this.answered = false;
    this.recordedBlobs = [];
    this.recordingStarted = false;
    this.eventEmitter = new EventEmitter();
    this.recEventEmitter = new EventEmitter();
    this.pingSent = 0;
    this.pongReceived = 0;
    this.peerconnectionTimeOut = null;
    this.peerTimeOutCount = 0;
    this.recPeerconnection = new RecordingRTCPeerConnection(false , this.eventEmitter);
    this.recEventEmitter.on('recDispatchMessage', (message) =>{
      this.sendMessage(message);
    })
    this.remoteStream = null;
    this.webSocketToastId = -1;
    this.state = {
      images: [],
      recordedvideos : [],
      callstate: "notjoined",
      endbuttondisabled : false,
      microphone: './images/microphone-on.png',
      startrecording : false,
      recordingText : "",
      isRecordingEnabled : false,
      captureDisabled: false,
      isReconnecting : false
    };

    this.handleConnectionChange = this.handleConnectionChange.bind(this);
  }

  componentDidMount() {
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);
    this.init();
    this.refreshImages(()=>{

    });

    this.refreshVideos(()=>{

    });
  }

  componentWillUnmount(){
    window.removeEventListener('online', this.handleConnectionChange);
    window.removeEventListener('offline', this.handleConnectionChange);
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  handleConnectionChange(event){
    console.log("Connection Change "+event.type);
  }

  render() {
    const { t } = this.props;
    if (this.state.callstate === "ended"){
      return (
        <Div100vh>
        <div className="PageTitle">
        <div className="Header">{t('videophone_title')}</div>
      </div>
        <div className="BodyStyle">
          <div className="BodyText">
          {t('call_ended')}
          </div>
        </div>
      </Div100vh>
      );
    }else if (this.state.callstate === "error"){
      return (
        <Div100vh>
        <div className="PageTitle">
        <div className="Header">{t('videophone_title')}</div>
      </div>
        <div className="BodyStyle">
          <div className="BodyText">
          {t('invalid_call_url')}
          </div>
        </div>
      </Div100vh>
      );
    }
    else {
      console.log("Recording "+this.state.isRecordingEnabled+ " "+this.state.startrecording);
      return (
        <Div100vh>
          {this.state.isReconnecting?<div className="Reconnecting">{t('connecting')}</div>:null}
          <div className="PageTitle">
            <div className="Header">{t('videophone_title')}</div>
          </div>
          <ToastContainer />
          <div className="BodyStyle">
            <div className="VideoCallHeader">
              <div className="SubTitleWrapper">
              <div className="SubTitle">{t('video_call_agent')}</div>
              </div>
              <div className="SubTitleWrapper">
              <div className="SubTitleCenter">{this.state.recordingText}</div>
              </div>
              {this.state.isRecordingEnabled?
                <div className="TitleButtonWrapper">
                  <button
                    className="TitleButtonStyle"
                    disabled={this.state.captureDisabled}
                    onClick={event => {
                      this.handleCapture();
                    }}
                    id="capture_id"
                  >
                    {t('capture')}
                  </button>
                </div> : null
              }
              {!this.state.startrecording && this.state.isRecordingEnabled ? (
                <div className="TitleButtonWrapper">
                  <button
                    className="TitleButtonStyle"
                    onClick={event => {
                      this.handleRecordingStart();
                    }}
                    id="startrecording_id"
                  >
                    {t('start_recording')}
                  </button>
                </div>
              ) : null}
              {this.state.startrecording && this.state.isRecordingEnabled ?
              (
                <div className="TitleButtonWrapper">
                  <button
                    className="TitleButtonStyle"
                    onClick={event => {
                      this.handleRecordingStop();
                    }}
                    id="stoprecording_id"
                  >
                    {t('stop_recording')}
                  </button>
                </div>
              ): null}
              <div className="TitleButtonWrapper">
                <button
                  className="TitleButtonStyle"
                  onClick={event => {
                    this.handleEndButton();
                  }}
                  id="end_id"
                >
                  {t('end')}
                </button>
              </div>
            </div>
            <div className="VideoContainerWrapper">
              <div className="VideoContainer">
                <div className="VideoContent">
                  <canvas hidden id="canvas" width="1280" height="720" className="photoCard" ref={(input) => this.canvasTag = input} />
                    <video
                      id="remoteVideo"
                      className="videoTag"
                      ref={ref => {
                        this.videoTag = ref;
                      }}
                      autoPlay
                      playsInline
                    />
                    <video
                      hidden
                      id="localVideo"
                      ref={ref => {
                        this.videoTagRemote = ref;
                      }}
                      playsInline
                      autoPlay
                    />
                  </div>
                  <div className="VideoCallFooter">
                  <div className="ImageContainerMiddle">
                    <img
                      key="unmuted"
                      className="iconStyle"
                      src={this.state.microphone}
                      alt=""
                      onClick={event => {
                        this.handleMicMute();
                      }}
                    />
                    </div>
                </div>
              </div>
              <div className="ImagesAndVideoContainer">
                  <CaptureImages
                      images={this.state.images}
                      t={this.props.t}
                      deleteImage={(img, callback)=>this.deleteImage(img, callback)}
                    />
                  <RecordedVideos
                      recordedvideos={this.state.recordedvideos}
                      t={this.props.t}
                      deleteVideo={(video, callback)=>this.deleteVideo(video, callback)}
                 />
              </div>
            </div>
          </div>
        </Div100vh>
      );
    }
  }

  deleteImage(img, callback){
    var splitString = img.split('/');
    var imageNameSplit = splitString[splitString.length - 1];
    const imageName = imageNameSplit.split("?")[0];    

    deleteImage(this.props.token, imageName, ()=>{
      this.refreshImages(()=>{
        callback();
      });
    });
  }

  deleteVideo(video, callback){
    console.log("deleteVideo "+video);
    var splitString = video.split('/');
    const videoNameSplit = splitString[splitString.length - 1];
    const videoName = videoNameSplit.split("?")[0];

    deleteVideo(this.props.token, videoName, ()=>{
      this.refreshVideos(()=>{
        callback();
      });
    });

    callback();

  }

  handleRecordingStart(){

    const msg = {
      id: "startRecording",
      userId: this.id,
      receiverId: this.receiverId,
      callID: this.props.callID,
      recording: "rec_"+this.props.callID
    };
    this.sendMessage(msg);
  }

  handleRecordingStop(){
    const msg = {
      id: "stopRecording",
      userId: this.id,
      receiverId: this.receiverId,
      callID: this.props.callID,
      recording: "rec_"+this.props.callID
    };
    this.sendMessage(msg);
  }

  handleEndButton(){
    endCall(this.props.token, true, (status)=>{
      if(status){
        this.handleEndCall();

        const msg = {
          role: this.props.isCustomer ? "share" : "viewer",
          id: "endCall",
          userId: this.id,
          receiverId: this.receiverId,
          callID: this.props.callID
        };
        this.sendMessage(msg);


        clearInterval(this.peerconnectionTimeOut);
        clearInterval(this.pingInterval);
        this.rws.close();
      }
    });
  }

  handleMicMute(){
    if(this.state.microphone ===  "./images/microphone-on.png"){
      this.mediaStream.getAudioTracks()[0].enabled = false;
      this.setState({microphone: "./images/microphone-off.png"});
    }else{
      this.mediaStream.getAudioTracks()[0].enabled = true;
      this.setState({microphone: "./images/microphone-on.png"});
    }
  }

  handleClick(event) {
    switch (event.currentTarget.dataset.id) {
      case "start_id":
        console.log("Start Call");
        this.setState({callstate : "joined", endbuttondisabled:true});
        break;

      case "end_id":
        console.log("End Call");
        endCall(this.props.token, true, (status)=>{
          if(status){
            this.handleEndCall();

            const msg = {
              role: this.props.isCustomer ? "share" : "viewer",
              id: "endCall",
              userId: this.id,
              receiverId: this.receiverId,
              callID: this.props.callID
            };
            this.sendMessage(msg);
          }
        });
        break;
      case "capturecall_id":
        console.log("Capture screenshot");
        break;

      default:
        break;
    }
  }

  handleEndCall(){
    this.setState({callstate : "ended"});

    if(this.peerConnection){
      this.peerConnection.close();
    }
    this.peerConnection = null;
    this.recPeerconnection.close();
    this.eventEmitter.removeAllListeners();

  }

  handleCapture(event) {
    this.setState({captureDisabled : true});
    var context = this.canvasTag.getContext("2d");
    console.log("Video width "+this.videoTag.videoWidth + " video height "+this.videoTag.videoHeight);
    this.canvasTag.width = this.videoTag.videoWidth? this.videoTag.videoWidth: 1280;
    this.canvasTag.height = this.videoTag.videoHeight?this.videoTag.videoHeight:720;
    context.drawImage(
      this.videoTag,
      0,
      0,
      this.canvasTag.width,
      this.canvasTag.height
    );

    var data = this.canvasTag.toDataURL('image/jpeg');
    uploadImage(this.props.token, data, (status) => {
      console.log("Status "+status);
      this.refreshImages(()=>{
        this.setState({captureDisabled : false});
      });


    });


    //this.photoTag.setAttribute('src', data);
  }

  refreshImages(callback){
    getImages(this.props.token, (status)=>{
      if(status){
        let statusJson = JSON.parse(status);
        let imagesNew = [];
        statusJson.urls.forEach((value)=>{
          imagesNew.push(value);
        })
        this.setState({ images: imagesNew });
      }else{
        toast(this.props.t("image_capture_failed"), {
          type: toast.TYPE.ERROR,
          autoClose: 2000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
      callback();
    });
  }

  refreshVideos(callback){
    getRecordedVideos(this.props.token, (status)=>{
      if(status){
        let statusJson = JSON.parse(status);
        let videosNew = [];
        statusJson.urls.forEach((value)=>{
          videosNew.push(value);
        })
        this.setState({ recordedvideos: videosNew });
      }else{
        toast(this.props.t("rec_fetch_error"), {
          type: toast.TYPE.ERROR,
          autoClose: 2000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
      callback();
    });
  }

  init() {
    const options = {
      maxRetries: 1000
    };
    this.rws = new ReconnectingWebSocket(Config.wsUrl, [], options);

    this.pingInterval = setInterval(()=>this.ping(), PING_INTERVAL);


    this.rws.addEventListener("message", event => {
      console.log(JSON.stringify(event));
      let message = JSON.parse(event.data);
      if(message.recording){
        this.handleRecordingMessage(event);
      }else{
        this.handleMessage(event);
      }
    });

    this.rws.addEventListener("open", event => {
      /*if(toast.isActive(this.webSocketToastId)){
        toast.dismiss(this.webSocketToastId);
        this.webSocketToastId = -1;
      }*/
      if(this.state.isReconnecting)
        this.setState({isReconnecting: false});

      console.log("Connection opened " + JSON.stringify(event));
      let msg = {};
      msg.id = "JoinCall";
      msg.callID = this.props.callID;
      msg.userId = this.id;
      msg.userType = this.props.isCustomer ? "Customer" : "Agent";
      this.rws.send(JSON.stringify(msg), error => {
        if (error) {
          this.logger(
            `client: Websocket error '${error}' on message '${msg.id}'`,
            { topic: "ws" }
          );
        }
      });
    });

    this.rws.addEventListener("error", event => {
      /*const toastOptions = {
        autoClose: false,
        type: toast.TYPE.WARNING,
        hideProgressBar: true,
        position: toast.POSITION.TOP_RIGHT,
        toastId: 101
      };
      if((this.webSocketToastId === 101) && toast.isActive(this.webSocketToastId)){
        // do nothing
      }else{
        if(this.webSocketToastId){
          toast.dismiss(this.webSocketToastId);
          this.webSocketToastId = -1;
        }
        this.webSocketToastId = toast("Error connecting to Videophone server... Retrying ...", toastOptions);
      }*/
      if(!this.state.isReconnecting)
        this.setState({isReconnecting: true});

      console.log("Websocket error agent "+this.id +" "+event.type);
      console.log("Connection opened " + JSON.stringify(event));
    });

    this.rws.addEventListener("close", event => {
      console.log("Websocket closed agent "+this.id +" "+event.reason);
      console.log("Connection opened " + JSON.stringify(event));
    });


    const constraints = {
      audio: {
        advanced: [{googEchoCancellation: {exact: true}}, {googAutoGainControl: {exact: true}}, {googNoiseReduction: {exact: true}}]
      },
      video: false
    };

    const handleSuccess = mediaStream => {
      this.mediaStream = mediaStream;
    };

    try {
      navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess);
    } catch (e) {
      console.error("navigator.getUserMedia error :", e);
    }

  }

  ping() {
    const message = {
      id: 'ping',
      callID: this.props.callID
    };
    this.sendMessage(message);
    this.pingSent++;
    if(this.rws)
      console.log("Reconnecting web socket "+this.rws.readyState);


      if(this.rws.readyState === 1){
        /*if(toast.isActive(this.webSocketToastId)){
          toast.dismiss(this.webSocketToastId);
          this.webSocketToastId = -1;
        }*/
        if(this.state.isReconnecting)
          this.setState({isReconnecting: false});        
      }
  


    if((this.pingSent -this.pongReceived) >= 2){
      this.rws.reconnect(100, "reconnect");
      console.log("Resetting ping count");
      this.pingSent = 0;
      this.pongReceived = 0;
    }

    if(this.peerConnection && this.peerConnection.getPeerConnectionState() === "connected"){
      this.setState({isReconnecting : false});
      if(this.peerconnectionTimeOut)
        clearInterval(this.peerconnectionTimeOut);
        
      delete this.peerconnectionTimeOut;
    }
    console.log("ping Sent " +  this.pingSent);
  }

  handleMessage(event) {
    //console.log("handleMessage:" + event.data);
    let message = JSON.parse(event.data);
    switch (message.id) {
      case "UserJoined":
        console.log("Users joined:" + event);
        this.id = message.userId;
        this.showToast(message.agentJoined, message.customerJoined);
        break;

      case "CallStateChanged":
        if (message.userId !== this.id) {
          if(message.msg === "CallerJoined"){
            this.receiverId = message.userId;
          }
          this.showToast(message.agentJoined, message.customerJoined);
        }
        clearInterval(this.peerconnectionTimeOut);
        if(this.peerConnection && this.peerConnection.getPeerConnectionState()=== "connected"){
          console.log("CallStateChanged peer already in connected state");
        }else{
          this.peerconnectionTimeOut = setInterval(() => {
            this.availableForCall();
          }, 5000);
        }
        if(this.recPeerconnection.isRecordingOngoing() && !message.recordingstatus){
          this.handleRecordingMessageInternal({id : "onStopRecording"});
        }
        console.log("CallStateChanged " + this.receiverId);
        break;

      case "sdpOffer":
        if (!this.props.isCustomer) {
          clearInterval(this.peerconnectionTimeOut);
          delete this.peerconnectionTimeOut;
          this.peerTimeOutCount = 0;

          if(this.peerConnection){
            this.peerConnection.closePeerConnection();
            this.eventEmitter.removeAllListeners();
            this.peerConnection = null;
          }
          this.createWebRTCPeer();
        }
        this.processOffer(message.sdpOffer);
        break;

      case "sdpAnswer":
        this.processAnswer(message.sdpAnswer);
        break;

      case "iceCandidate":
        this.handleIceCandidate(message.candidate);
        break;

      case "endCall":
          this.handleEndCall();
          clearInterval(this.peerconnectionTimeOut);
          clearInterval(this.pingInterval);
          this.rws.close();
          break;

      case 'pong':
          this.pongReceived++;
          console.log("ping Received " +  this.pongReceived);

        break;
        
      case "Error":
          this.setState({callstate : "error"});
          if(this.rws){
            this.rws.close();
          }          
          break;
        

      default:
        break;
    }
  }

  handleRecordingMessage(event){
    let message = JSON.parse(event.data);

    switch(message.id){
      case "onStartRecording":
          if(this.recordingToastID){
            toast.dismiss(this.recordingToastID);
          }
        this.recordingToastID =  toast(this.props.t("rec_started"), {
            type: toast.TYPE.INFO,
            autoClose: 5000,
            hideProgressBar: true,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
          this.setState({startrecording : true});
          this.setState({recordingText: this.props.t("rec_in_progress")});
        break;

        case "onStopRecording":
            if(this.recordingToastID){
              toast.dismiss(this.recordingToastID);
            }
          this.recordingToastID = toast(this.props.t("rec_stopped"), {
            type: toast.TYPE.INFO,
            autoClose: 5000,
            hideProgressBar: true,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
            this.setState({startrecording : false});
            this.setState({recordingText: ''});
            this.refreshVideos( ()=>{

            });
          break;

          case "onStartRecordingError":
            this.recordingToastID = toast(this.props.t("rec_start_error"), {
              type: toast.TYPE.ERROR,
              autoClose: 5000,
              hideProgressBar: true,
              closeButton: null // The closeButton defined on ToastContainer will be used
            });
          break;

          case "onStopRecordingError":
            this.recordingToastID = toast(this.props.t("rec_stop_error"), {
              type: toast.TYPE.ERROR,
              autoClose: 5000,
              hideProgressBar: true,
              closeButton: null // The closeButton defined on ToastContainer will be used
            });
          break;

          default:
            break;
    }
    this.recPeerconnection.handleMessage(message);
  }

  showToast(agentJoined, customerJoined){
    const options = {
      autoClose: false,
      type: toast.TYPE.INFO,
      hideProgressBar: true,
      position: toast.POSITION.TOP_RIGHT
    };

    if(this.toastId){
      toast.dismiss(this.toastId);
    }

    if(agentJoined && !customerJoined){
      this.toastId = toast(this.props.t("customer_join_wait"), options);
    }else if (!agentJoined && customerJoined){
      this.toastId = toast(this.props.t("agent_join_wait"), options);
    }
  }

  async createWebRTCPeer() {
    if(this.peerConnection)
      return;

    const offerOptions = {
      offerToReceiveAudio: 1,
      offerToReceiveVideo: 1
    };

    this.peerConnection = new PeerConnection(this.eventEmitter, offerOptions, this.mediaStream);
    this.recPeerconnection.set (this.recEventEmitter, offerOptions, this.mediaStream, this.props.callID, this.id);


    this.peerConnection.on('iceCandidate', (candidate)=>{
      const message = {
        type: "icecandidate",
        role: this.props.isCustomer ? "share" : "viewer",
        id: "iceCandidate",
        candidate: candidate,
        userId: this.id,
        callID: this.props.callID,
        receiverId: this.receiverId
      };

      console.log("Message icecandidate "+ JSON.stringify(message));
      this.sendMessage(message);
    });

    this.peerConnection.on('remoteStream', (stream)=>{
      this.remoteStream = stream;
      this.videoTag.srcObject = null;
      this.setState({isRecordingEnabled : true });
      if (this.processedAnswer) {
        if (this.videoTag.srcObject !== stream) {
          this.videoTag.srcObject = stream;
          console.log("received remote stream remoteStream");
        }
      }
    });


    this.peerConnection.on('onIceStateChange', (state)=>{
      if((state === "closed") || (state === "failed")){
        if(this.peerConnection){
          if(this.videoTag){
            this.videoTag.srcObject = null;
          }
          this.peerConnection.closePeerConnection();
          this.eventEmitter.removeAllListeners();
          this.peerConnection = null;
          const msg = {
            type: "icecandidate",
            role: this.props.isCustomer ? "share" : "viewer",
            id: "iceStateFailed",
            userId: this.id,
            callID: this.props.callID,
            receiverId: this.receiverId
          };
          this.sendMessage(msg);

          //this.availableForCall();
          clearInterval(this.peerconnectionTimeOut);
          this.peerconnectionTimeOut = setInterval(() => {
            this.availableForCall();
          }, 5000);

        }
        this.setState({isReconnecting : true});
      }else if (state === "disconnected"){
        this.setState({isReconnecting : true});
      }else if (state === "connected"){
        this.setState({isReconnecting : false});
      }

    });    

/*

    const offer = this.peerConnection.createOffer();
      try {
        const message = {
          role: this.props.isCustomer ? "share" : "viewer",
          id: "sdpOffer",
          sdpOffer: offer,
          userId: this.id,
          receiverId: this.receiverId,
          callID: this.props.callID
        };
        this.sendMessage(message);
      } catch (e) {} */
    //}
  }

  async processOffer(offer) {
    const answer = await this.peerConnection.processOffer(offer);
    console.log("processOffer " + JSON.stringify(answer));
    const msg = {
      role: this.props.isCustomer ? "share" : "viewer",
      id: "sdpAnswer",
      sdpAnswer: answer,
      userId: this.id,
      receiverId: this.receiverId,
      callID: this.props.callID
    };
    this.sendMessage(msg);
    this.processedAnswer = true;
      if (this.videoTag.srcObject !== this.remoteStream) {
        this.videoTag.srcObject = this.remoteStream;
        console.log("received remote stream processOffer");
        this.setState({isRecordingEnabled : true });
      }
  }

  async processAnswer(answer){
    await this.peerConnection.processAnswer(answer);
  }

  async handleIceCandidate(candidate){
    await this.peerConnection.handleIceCandidate(candidate);
  }

  availableForCall(){
    console.log("availableForCall "+ this.receiverId);
    if(this.receiverId){
      const msg = {
        role:  "viewer",
        id: "availableForCall",
        userId: this.id,
        receiverId: this.receiverId,
        callID: this.props.callID
      };
      this.sendMessage(msg);
      this.peerTimeOutCount++;
      this.setState({isReconnecting : true});
    }
  }


  sendMessage(msg) {
    this.rws.send(JSON.stringify(msg), error => {
      if (error) {
        console.log(
          `client: Websocket error '${error}' on message '${msg.id}'`,
          { topic: "ws" }
        );
      }
    });
  }

  /*startRecording(stream) {
    if (
      this.videoTag.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA &&
      this.videoTag.currentTime > 0 &&
      !this.videoTag.paused
    ) {
      // OK to start recording
      console.log("OK to record");
    } else {
      setTimeout(() => {
        this.startRecording(this.videoTag.srcObject);
      }, 2500);
      console.log("Recording Deferred");
      return;
    }

    if (this.recordingStarted) return;
    this.recordingStarted = true;
    console.log("Start Recording");
    let options = { mimeType: "video/webm;codecs=vp9" };

    if (MediaRecorder.isTypeSupported(options.mimeType)) {
      console.log("Supported video/webm;codecs=vp9");
    }

    console.log("MediaRecorder " + this.videoTag.readyState);

    try {
      this.mediaRecorder = new MediaRecorder(stream);
    } catch (e) {
      console.error("Exception while creating MediaRecorder:", e);
      return;
    }
    this.mediaRecorder.onstop = event => {
      console.log("Recorder stopped: ", event);
    };
    this.mediaRecorder.ondataavailable = event =>
      this.handleDataAvailable(event);
    this.mediaRecorder.start(10); // collect 10ms of data
  }

  handleDataAvailable(event) {
    if (event.data && event.data.size > 0) {
      console.log(
        "event.data.size hi222 " + event.data.size + " " + event.data
      );
      this.recordedBlobs.push(event.data);
      //this.rws.binaryType = "blob";
//      this.rws.send(event.data);
      // streamData(event.data);
    }
  }*/
}

export default Agent;